import { z } from 'zod';

/** Locale codes the platform supports. cs-CZ is the authored default; others are future-proofing. */
export const localeCodeSchema = z.enum(['cs-CZ', 'uk-UA', 'en-US', 'sk-SK']);
export type LocaleCode = z.infer<typeof localeCodeSchema>;

const nonEmpty = z.string().min(1);

/**
 * cs-CZ is required (the renderer falls back to it); every other locale is
 * optional. Matches the locked-contract `LocalizedText` type.
 */
export const localizedTextSchema = z
  .object({
    'cs-CZ': nonEmpty,
    'uk-UA': nonEmpty.optional(),
    'en-US': nonEmpty.optional(),
    'sk-SK': nonEmpty.optional(),
  })
  .strict();

export type LocalizedText = z.infer<typeof localizedTextSchema>;
